<div class="main_container">
  <app-sidebar></app-sidebar>
  <div [class]="!toggle ? 'main' : 'main toggle_main'" [class.ml-0_pt-10]="!resetMarginLeft()">
    <app-navbar></app-navbar>
    <router-outlet
      (activate)='onActivate($event)'
      (deactivate)='onDeactivate($event)'
    ></router-outlet>
  </div>
  <app-ai-chat-drawer
    [open]="aiChatDrawerOpen"
    (closed)="closeAiChatDrawer()"
  ></app-ai-chat-drawer>

  <!--
    First-time experience (WB-7535). Mounted once for the whole app: the layer
    renders whichever tip the presenter has decided to show, in a body-level
    overlay anchored to the element the tip points at. The inspector next to it
    only renders behind its dev flag.
  -->
  <ui-ftue-layer></ui-ftue-layer>
  <ui-ftue-inspector></ui-ftue-inspector>
</div>


